export enum CircleColor {
  RED = 'red',
  GREEN = 'green',
  GREY = 'grey',
}
